import Template from "backbone/projects/templates/add_topics.js.hamlc"

export default class AddTopicsView extends Backbone.View
  initialize: (options) ->
    @project = options.project
    @getFormData = options.getFormData
    @topics = options.topics

  render: ->
    @$el.html(Template(project: @project, topics: @topics))
    @$form = @$el.find("form")

  submitAndFinishLater: ->
    if @$form.exists() && @$form.parsley().isValid()
      @maskAndSave()
    else
      @project.set(savePending: false)

  submitAddTopicsForm: ->
    if @$form.exists() && @$form.parsley().validate()
      @maskAndSave()

  maskAndSave: ->
    @$form.maskLoading()
    formdata = @getFormData(@$form)
    @project.set(savePending: true)
    @project.save(formdata, {
      wait: true
      success: (model, response, options) =>
        @project.set(addTopicsSucceeded: true, savePending: false, topics: response.topics)
      error: =>
        @project.set(addTopicsSucceeded: false, savePending: false)
    }).always =>
      @$form.unmaskLoading()



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/add_topics_view.js.coffee